import { MutableRefObject, useEffect, useRef } from "react";

export const useSwipable = <T extends HTMLElement>(ref: MutableRefObject<T | null>) => {
    const isMouseDownRef = useRef(false);

    const setEventListeners = (element: T) => {
        element.addEventListener("mousedown", handleMouseDown);
        element.addEventListener("mousemove", handleMouseMove);
        element.addEventListener("mouseup", handleMouseUp);
        element.addEventListener("mouseleave", handleMouseLeave);
    };

    const handleMouseDown = () => {
        isMouseDownRef.current = true;
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (!isMouseDownRef.current || !ref.current) return;
        ref.current.scrollLeft -= e.movementX;
    };

    const handleMouseUp = () => {
        isMouseDownRef.current = false;
    };

    const handleMouseLeave = () => {
        isMouseDownRef.current = false;
    };

    useEffect(() => {
        if (!ref.current) return;
        setEventListeners(ref.current);

        return () => {
            if (!ref.current) return;

            ref.current.removeEventListener("mousedown", handleMouseDown);
            ref.current.removeEventListener("mousemove", handleMouseMove);
            ref.current.removeEventListener("mouseup", handleMouseUp);
            ref.current.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, [ref]);
};
